import { ViewModel, View, ObservableArray } from "binder"
import { ToolTypeManipulationView } from "./toolTypeManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ToolTypeEditorViewModel, ToolTypeInserter, ToolTypeUpdater } from "./toolTypeEditor/toolTypeEditor-viewModel";
import { IToolType } from "./IToolType";

export class ToolTypeManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف نوع ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.toolTypes = ObservableArray.create<ToolType>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolTypeManipulationView();
    }
    public getTypeId(): string {
        return "VM-1F9D3964-23AF-464E-9B10-D95C7D6D8728"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolTypes(v: ObservableArray<ToolType>) { this._toolTypes = v; } public get toolTypes(): ObservableArray<ToolType> { return this._toolTypes; } private _toolTypes: ObservableArray<ToolType>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolTypeServices/ListAllToolTypes', {
                FilteringInformation: filteringInformation
            });
            this.toolTypes.update(...result.ToolTypes.map((x, i) => {
                let t = new ToolType(this);
                t.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                t.id = x.Id;
                t.name = x.Name;
                t.code = x.Code;
                return t;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ToolTypeEditorViewModel(this, new ToolTypeInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(toolType: IToolType) {
        let popup = new ToolTypeEditorViewModel(this, new ToolTypeUpdater());
        await toolType.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(toolType: ToolType): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ToolTypeServices/DeleteToolType", {
                    ToolTypeId: toolType.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ToolType extends ViewModel implements IToolType {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolTypeManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ToolTypeManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;

    async cloneTo(toolType: IToolType) {
        toolType.id = this.id;
        toolType.name = this.name;
        toolType.code = this.code;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
